import axios from "axios";
import authHeader from "../auth-header";

const API_URL_SELL = process.env.REACT_APP_API_SELLS_URL;

const getAll = async () => {
  return await axios.get(`${API_URL_SELL}/sell-requirements`, {
    headers: authHeader(),
  });
};

const getAllByOpportunity = async (id, origin = "observed") => {
  return await axios.get(`${API_URL_SELL}/sell-requirements/${origin}/${id}`, {
    headers: authHeader(),
  });
};

const insert = (id, requirements) => {
  return axios
    .post(
      `${API_URL_SELL}/sell-requirements/${id}`,
      { requirements },
      { headers: authHeader() }
    )
    .then((response) => {
      if (response.data.success) {
        return response.data;
      }
      throw new Error(response.data.message);
    });
};

const updateOne = (id, opportunity_id, status) => {
  return axios
    .put(
      `${API_URL_SELL}/sell-requirements/${id}/${opportunity_id}/${status}`,
      {},
      { headers: authHeader() }
    )
    .then((response) => {
      if (response.data.success) {
        return response.data;
      }
      throw new Error(response.data.message);
    });
};

const updateAll = (id, requirements) => {
  return axios
    .patch(
      `${API_URL_SELL}/sell-requirements/${id}`,
      { requirements },
      { headers: authHeader() }
    )
    .then((response) => {
      if (response.data.success) {
        return response.data;
      }
      throw new Error(response.data.message);
    });
};

export default {
  getAll,
  getAllByOpportunity,
  insert,
  updateOne,
  updateAll,
};
